import { notification } from "antd";
import {
  UPDATE_UTILISATEUR_REQUEST,
  UPDATE_UTILISATEUR_SUCCESS,
  UPDATE_UTILISATEUR_FAILURE,
} from "../Types";
import { apiPut } from "../../services/apiInterceptor";

export const updateUtilisateur = (updatedData) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_UTILISATEUR_REQUEST });

    try {
      // ✅ MIGRATION : Plus besoin de gérer manuellement le token
      const response = await apiPut("api/users/update-profile", updatedData);

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data?.error || "Erreur lors de la mise à jour de l'utilisateur"
        );
      }

      dispatch({ type: UPDATE_UTILISATEUR_SUCCESS, payload: data });

      notification.success({
        message: data?.message,
        duration: 5,
      });
      return data;
    } catch (error) {
      dispatch({ type: UPDATE_UTILISATEUR_FAILURE, payload: error?.message });

      notification.error({
        message: error?.message || "Erreur lors du mis à jour de l'utilisateur",
        duration: 5,
      });
    }
  };
};
